import { render } from "./DocsBase.vue?vue&type=template&id=04251e2b"
import script from "./DocsBase.vue?vue&type=script&lang=js"
export * from "./DocsBase.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./DocsBase.vue?vue&type=style&index=0&id=04251e2b&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script